module.exports = __webpack_public_path__ + "img/image126.111aa0a3.png";